<template>
  <div class="masterCon">
       
        <div v-show="offModel">
            <div class="top">
                <Button type="success" class="addButton"  @click="addData(1)" style="margin-right:8px;">{{$t("setting.addTitle")}}</Button>
            </div>
    
            <Table  :columns="titleName" :data="tableList.tableData"   @on-sort-change="sortCustom" ref="selection"  :loading='loading'></Table>
    
            <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,20,30,50]" placement="top" class="pages"/>

        </div>
          <!-- 添加  经销商账户 -->
        <ModelBox  :offModel.sync='offModel' :showModel.sync="addBox.showModel" :fn="addBox.callbackFn" :type="type" :editFormData="addBox.editFormData"></ModelBox>
        

  </div>
</template>
<script>
import common from '@/common/common.js';
import axios from 'axios'
import ModelBox from './addModelNew';
import moment from 'moment';
import { mapMutations } from 'vuex'

    export default {
        name: "merchantAdmin",
        components: {
            ModelBox
        },
        data(){
            return{
                loading: true,
                type:1,//弹框打开类型 1添加 2编辑
                tableList:{//表格组
                    hasSelectData:{},//已选中的行的数据
                    tableData: [],//表格数据
                    tableDataAll:[]
                },
                addBox:{//规格弹框组-新增
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                offModel: true,
                page:{//分页排序
                    total:0,//总条数
                    pageSize:10,//每页条数
                    current:1,//当前页
                    key:'orderDate',
                    order:'desc'
                }
            }
        },
        computed:{
            local(){
               return this.$store.state.local
            },
            roleType(){
	        	let res = '2'
	        	if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	        	 res = this.$store.state.uInfo.roleType
	        	}
	        	return res
	        },
            searchObjArr(){
                return   {
                    is_share:[
                        {id: 1,val:this.$t('selectList.functionCategoryList.Water_equipment')},
                        {id: 2,val:this.$t('selectList.functionCategoryList.Water_equipment')},
                    ]
                }
            },
            titleName(){
                 return [
                    {
                        title: this.$t('setting.id'),
                        key: 'id',
                        sortable: true,
                        minWidth: 180,
                        render:(h,params)=>{
                          return h('div',{
                              style:{
                                  cursor:'pointer'
                              },
                              on:{
                                  'click':()=>{
                                      this.toDealer(params.row.id)
                                  }
                              }
                          },params.row.id)
                        }
                    },
                    {
                        title: this.$t('setting.companyName'),
                        key: 'companyName',
                        minWidth: 180,
                       
                    },
                    {
                        title: this.$t('setting.companyAddress'),
                        key: 'companyAddress',
                        sortable: true,
                        minWidth: 180
                    },
                    {
                        title:this.$t('setting.starLevel'),
                        key: 'starLevel',
                        minWidth: 120
                    },
                    {
                        title: this.$t('setting.email'),
                        key: 'email',
                        minWidth: 240
                    },
                    {
                        title: this.$t('setting.registerTime'),
                        key: 'registerTime',
                        minWidth: 180,
                        render:(h, params)=>{
                            let stext = moment(params.row.registerTime*1).format('YYYY-MM-DD HH:mm')
                             return h('div',stext || '')
                        }
                    }
                ]
            } 
        },
        created() {
           
            this.getData();
       
        },
        watch: {
        
        },
        methods: {
            ...mapMutations([
                'setSelectId',
                'setShowChildrenSide',
                'setTabMenuList',
                'setTabMenuItem',
                'setDealerToken'
       
            ]),
            toDealer(id){//跳转经销商
                this.axios.post(this.config.urlArray.chooseDealer, {id}).then((result) => {
                    // console.log('result',result)
                    common.ajaxMsg(result.data,false,()=>{
                        this.setSelectId(id)             
                        this.setDealerToken(result.data.data)    
                        axios.defaults.headers.common['Authorization'] = result.data.data;
                        this.setShowChildrenSide(false) //
                        let tabMenuList = this.$store.state.tabList
                        if(tabMenuList.length>1){
                          this.setTabMenuList([tabMenuList[0]]);
                          this.setTabMenuItem(tabMenuList[0]);
                        }
                    })
                })
            },
            
            getData() {//获取数据
                let getData = {
                    page: this.page.current,
                    limit: this.page.pageSize,
                    roleType:2
                  
                }
                this.axios.post(this.config.urlArray.dealerpageList, getData).then((result) => {
                    common.ajaxMsg(result.data,false,()=>{
                        let resData = result.data.data.dealersList
                        this.tableList.tableData = resData
                        this.page.total = result.data.data.meta.count
    
                        this.loading = false
                    })
                }).catch((err) => {
                    common.msg('error',err,()=>{})
                });
            },
           
            addData(type) {  //添加或编辑数据
                if(this.roleType==2) return
                this.addBox.showModel = true
                this.offModel = false
                this.type = type
                if(type == 2) {
                    this.addBox.editFormData = this.tableList.hasSelectData
                }
                this.addBox.callbackFn = () => {
                    this.addBox.showModel = false;
                    this.getData();
                }
            },
     
            sortCustom(data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            changePage(nowpage) {//切换分页
                this.page.current = nowpage;
                this.getData();
            },
            changeSize(nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            },
        }
    }
</script>
<style lang="less">
    .top{

        margin: 10px auto 30px
    }
    .pages{

        margin: 30px auto
    }
    .masterCon{

        background: #fff;
        padding: 20px;
        margin: 42px 40px 8px 10px
    }
    .addButton{

        border-radius: 6px;
    }
</style>

